import { USAGE_POLICY } from '@/components/utils/legalDocuments';
import { getTermsOfUseLink } from '@/helpers/localiseHelper';
import { Link } from '@heidi/design-system/link';
import { TypographyCaption } from '@heidi/design-system/typography';
import { FormattedMessage, useIntl } from 'react-intl';

const ProductUsageDisclaimer = () => {
  const intl = useIntl();
  const locale = intl.locale;
  const termsUrl = getTermsOfUseLink(locale);

  return (
    <TypographyCaption className="text-center text-text-secondary">
      <FormattedMessage
        defaultMessage="By using this product, you acknowledge and agree to abide by the <termsLink>Terms of Use</termsLink> and <policyLink>Usage Policy</policyLink>. Please ensure you review and understand the terms before proceeding."
        id="GfPGr+wuoM"
        description="Legal disclaimer with links to Terms of Use and Usage Policy, shown near onboarding or signup."
        values={{
          termsLink: (chunks) => (
            <Link
              href={termsUrl}
              target="_blank"
              rel="noopener noreferrer"
              variant="inline"
            >
              {chunks}
            </Link>
          ),
          policyLink: (chunks) => (
            <Link
              href={USAGE_POLICY}
              target="_blank"
              rel="noopener noreferrer"
              variant="inline"
            >
              {chunks}
            </Link>
          ),
        }}
      />
    </TypographyCaption>
  );
};

export default ProductUsageDisclaimer;
